import { render, staticRenderFns } from "./QueuesTagInfo.vue?vue&type=template&id=28d41aab"
import script from "./QueuesTagInfo.vue?vue&type=script&lang=js"
export * from "./QueuesTagInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports